// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3G5Nj","inner":"Footer_inner__1ZaIO","nextIcon":"Footer_nextIcon__3yX1o","innerLeft":"Footer_innerLeft__3sf-P"};